
import axios from 'axios'
import {Base64} from "js-base64";
export const common = {

    isMobile: function(){
        let user = navigator.userAgent;
        let w_type = false
        if(user.toLowerCase().indexOf('iphone') > -1 || user.toLowerCase().indexOf('ipad') > -1 || user.toLowerCase().indexOf('ipod') > -1 || user.toLowerCase().indexOf('android') > -1){
            w_type = true
        }

        console.log('isMobile', w_type)
        return w_type
    }
    , getIp: async function(){
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            if(response){
                return response.data.ip
            }else{
                throw 'error'
            }
        } catch (error) {
            console.error(error);
        }
    }

    , setSessionSandpay: function(data){
        let t = Base64.encode('sandpay')
        let d = Base64.encode(JSON.stringify(data))
        sessionStorage.setItem(t, d)
    }

    , getSessionSandpay: function(){
        let t = Base64.encode('sandpay')
        let d = sessionStorage.getItem(t)

        if(d){
            d = JSON.parse(Base64.decode(d))
        }

        return d
    }
    , destroySessionSandpay: function(){
        let t = Base64.encode('sandpay')
        sessionStorage.removeItem(t)
    }
}